import { MyModel, MyModelDetail } from "@/types/creatorcenter";
import {
  Box,
  Button,
  Flex,
  HStack,
  SimpleGrid,
  Text,
  useBreakpointValue,
  Image,
  useDisclosure,
} from "@chakra-ui/react";
import { RiAddCircleFill } from "@remixicon/react";
import modelImg from "@/assets/images/creator_model_img1.png";
import intergralIcon from "@/assets/images/icon_integral.png";
import NewTrainingModal from "@/components/creatorcenter/newTrainingModal";
import PayCenterModal from "@/components/payCenterModal";
import ModelTrainingItem from "@/components/creatorcenter/modeltrainingitem";
import {
  useCreateTrainMutation,
  useGetTrainsQuery,
  useLazyGetTrainsQuery,
} from "@/services/api/endpoints/model";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import { useAppDispatch } from "@/store/hooks";
import {
  resetMyModel,
  updateCurrentTrainId,
  updateModelPublishParams,
  updateTrainingPictures,
} from "@/reducer/mymodelSlice";
import { useEffect, useState } from "react";
import TraingResultModal from "@/components/creatorcenter/trainingResultModal";
import EditModelDetailModal from "@/components/creatorcenter/editModelDetailModal";

const ModelTraning = () => {
  const column = useBreakpointValue({
    base: 1, // 屏幕宽度小于40em（640px）时的值
    sm: 2, // 屏幕宽度在40em-52em（640px-853px）之间时的值
    md: 2, // 屏幕宽度在52em-64em（853px-1024px）之间时的值
    lg: 4, // 屏幕宽度在64em-80em（1024px-1280px）之间时的值
    xl: 5, // 屏幕宽度在80em-100em（1280px-1920px）之间时的值
  });

  const NewTrainingControl = useDisclosure();
  const PayControl = useDisclosure();
  const ResultControl = useDisclosure();
  const editControl = useDisclosure();

  const dispatch = useAppDispatch();
  const user = useSelector(selectUser);

  // const { data: trainsList } = useGetTrainsQuery({user_id: user.id});
  const [getTrains] = useLazyGetTrainsQuery();
  const [createTrain] = useCreateTrainMutation();

  const [trainsList, setTrainsList] = useState<MyModelDetail[]>([]);

  console.log(trainsList, "trainsList>>>>>>>>>>>");

  const updataTrainList = async () => {
    const dataList = await getTrains({ user_id: user.id });
    if (dataList.data) {
      setTrainsList(dataList.data);
    }
  };
  useEffect(() => {
    updataTrainList();
  }, []);

  const handleNewTraining = async () => {
    dispatch(resetMyModel());
    dispatch(updateTrainingPictures([]));
    const result = await createTrain({
      userId: user.id,
      train_status: "未开始",
    });
    if (result) {
      console.log(result);
      dispatch(updateCurrentTrainId(result.data.id));
      dispatch(updateModelPublishParams({ ...result.data }));
      updataTrainList();
      NewTrainingControl.onOpen();
    }
  };

  //   充值会员
  const handleRechargeMembership = () => {
    PayControl.onOpen();
  };

  const handleOpenResult = () => {
    ResultControl.onOpen();
  };

  const handleOpenPublish = () => {
    editControl.onOpen();
  };

  return (
    <Box h="100%" pl="20px" pr="20px">
      <Flex mb="20px" justifyContent={"space-between"} alignItems="center">
        <Box fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
          模型训练
        </Box>
        <HStack spacing={0}>
          <Flex
            h="40px"
            bg="rgba(238, 241, 247, 0.5)"
            gap="8px"
            alignItems={"center"}
            pl="10px"
            pr="15px"
          >
            <Image boxSize={"18px"} src={intergralIcon} />
            <Text color="#496AE1" fontWeight={"bold"} fontSize="14px">
              {user.totalcoin}
            </Text>
          </Flex>
          <Button
            borderRadius={0}
            width={"90px"}
            height={"40px"}
            color="#FFFFFF"
            bgColor="#496AE1"
            fontWeight={"normal"}
            fontSize="12px"
            _hover={{
              bgColor: "#3F5BC1",
              color: "#E6E6E6",
            }}
            onClick={handleRechargeMembership}
          >
            特惠升级
          </Button>
        </HStack>
      </Flex>
      <Box
        h="calc(100% - 60px)"
        overflow={"auto"}
        borderWidth="1px"
        borderColor={"#DCE0EB"}
        p="20px"
      >
        <Box>
          <SimpleGrid columns={column} spacing={"40px 20px"}>
            <Box
              h="160px"
              bg={"rgba(238, 241, 247, 0.5)"}
              cursor="pointer"
              onClick={handleNewTraining}
            >
              <Flex
                h={"100%"}
                flexDir="column"
                gap={"18px"}
                justifyContent={"center"}
                alignItems="center"
              >
                <RiAddCircleFill color="#CBD1DF" size={"64px"} />
                <Text fontSize={"18px"} color="#8E94A9">
                  新建训练
                </Text>
              </Flex>
            </Box>
            {trainsList &&
              trainsList.map((item) => (
                <Box key={item.id}>
                  <ModelTrainingItem
                    myModel={item}
                    handleOpenResult={handleOpenResult}
                  />
                </Box>
              ))}
          </SimpleGrid>
        </Box>
      </Box>

      <NewTrainingModal
        isOpen={NewTrainingControl.isOpen}
        onClose={NewTrainingControl.onClose}
        handleOpenResult={handleOpenResult}
      />

      <PayCenterModal
        tabIndex={0}
        isOpen={PayControl.isOpen}
        onClose={PayControl.onClose}
      />

      <TraingResultModal
        isOpen={ResultControl.isOpen}
        onClose={ResultControl.onClose}
        handleOpenPublish={handleOpenPublish}
      />
      <EditModelDetailModal
        isOpen={editControl.isOpen}
        onClose={editControl.onClose}
      />
    </Box>
  );
};

export default ModelTraning;
